import { axios } from '../config/axios';

const endPoint = '/project/candidate';

const downloadCandidateTemplate = () => {
    return axios.get(`${endPoint}/download-candidate-template`, {
        responseType: 'blob'
    });
}

const getPresentCount = (projectMasterId) => {
    return axios.get(`${endPoint}/present-count/${projectMasterId}`);
}

const downloadAttendanceSheet = (projectMasterId) => {
    return axios.get(`${endPoint}/download-attendance-sheet/${projectMasterId}`, {
        responseType: 'blob'
    });
}

const getListForUpdateTime = async (projectMasterId, examHallId, searchTerm, pageNumber, limit) => {
    return axios.post(`${endPoint}/list-for-update-time`, {
        projectMasterId: projectMasterId,
        examHallId: examHallId ?? 0,
        search: searchTerm,
        page: pageNumber,
        limit: limit
    });
}

const getServerSummaryList = async (projectMasterId, serverId, examHallId, pageNumber, limit) => {
    return axios.post(`${endPoint}/list-for-server-summary`, {
        projectMasterId: projectMasterId,
        serverId: serverId,
        examHallId: examHallId,
        page: pageNumber,
        limit: limit
    });
}

const getListAllByPage = async (projectMasterId, searchTerm, pageNumber, limit) => {
    return axios.post(`${endPoint}/list-all-by-project-master-with-pagination`, {
        projectMasterId: projectMasterId,
        search: searchTerm,
        page: pageNumber,
        limit: limit
    });
}

const deleteCandidate = async (candidateId) => {
    return axios.delete(`${endPoint}/delete-candidate/${candidateId}`)
}

const clearLoggedInCount = (candidateId) => {
    return axios.post(`${endPoint}/clear-logged-in-count`, {
        candidateId: candidateId,
    });
}

const changeDisabledStatus = (candidateId, status, reason) => {
    return axios.post(`${endPoint}/change-disabled-status`, {
        candidateId: candidateId,
        isDisabled: status,
        disabledReason: reason,
    });
}

const changeTechnicalIssueOccurredStatus = (candidateId, status) => {
    return axios.post(`${endPoint}/change-technical-issue-occurred-status`, {
        candidateId: candidateId,
        technicalIssueOccurred: status
    });
}

const downloadAuditLogReportByRollNo = (rollNo) => {
    return axios.get(`${endPoint}/download-audit-log-report/${rollNo}`, {
        responseType: 'blob'
    });
}

const downloadAnswerPaperByRollNos = (body) => {
    return axios.post(`${endPoint}/download-answer-paper`, body, {
        responseType: 'blob'
    });
}

export {
    downloadCandidateTemplate,
    getPresentCount,
    downloadAttendanceSheet,
    getListForUpdateTime,
    getServerSummaryList,
    getListAllByPage,
    deleteCandidate,
    clearLoggedInCount,
    changeDisabledStatus,
    changeTechnicalIssueOccurredStatus,
    downloadAuditLogReportByRollNo,
    downloadAnswerPaperByRollNos,
}